/**
 * builds a query string from the given params, omitting any that are null or
 * undefined. Interpolating an absent value straight into a template literal
 * yields the literal text "undefined", which fails model binding on typed API
 * parameters (ARB-11131).
 * @param {object}
 * @returns {string}
 */
export const queryString = params => {
  const pairs = Object.entries(params)
    .filter(([, value]) => value !== null && value !== undefined)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`);
  return pairs.length ? `?${pairs.join('&')}` : '';
};
